import { z } from "zod";

export const DressCodeSchema = z.object({
  display_name: z.string().optional(),
  description: z.string(),
});

export const DressCodesSchema = z
  .object({
    $schema: z.string().optional(),
  })
  .catchall(DressCodeSchema)
  .default({
    greys: {
      description: "Solid grey collared shirt and shorts or pants.",
    },
    standard_blacks: {
      description: "Solid black collared shirt, black pants, and neutral colored shoes.",
    },
    show_blacks: {
      description: "Solid black collared shirt, black pants, black shoes.",
    },
    dress_blacks: {
      description: "Black button-up shirt, black pants/slacks, black shoes.",
    },
  });
